module.exports = __webpack_public_path__ + "img/chevron-forward-outline.4a904fc6.svg";